module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Washer-106aec7235a20db1e4968f3cf1baf296.svg";